import { render, staticRenderFns } from "./ClinicDoctorsEdit.vue?vue&type=template&id=c493e0ac&scoped=true"
import script from "./ClinicDoctorsEdit.vue?vue&type=script&lang=js"
export * from "./ClinicDoctorsEdit.vue?vue&type=script&lang=js"
import style0 from "./ClinicDoctorsEdit.vue?vue&type=style&index=0&id=c493e0ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c493e0ac",
  null
  
)

export default component.exports